import { ClassSpecial } from '@op/constants/common';
import React from 'react';
import { Segment, Tabs, TabPanel } from 'tea-component';
import { SummaryTabItem } from './types';
import useLanguage from '@op/hooks/useLanguage';

export default function RichBodyBox({
  hasTabs,
  activeTab,
  setActiveTab,
  options,
  children,
  tabsOptionStyle,
}: {
  hasTabs: boolean;
  activeTab: string;
  setActiveTab: (value: string) => void;
  options: SummaryTabItem[];
  tabsOptionStyle?: React.CSSProperties;
  children: (item: SummaryTabItem, index: number) => JSX.Element;
}) {
  const { isEn } = useLanguage();
  return (
    <>
      {hasTabs && (
        <Segment
          style={tabsOptionStyle}
          className={`card-slot-segment`}
          value={activeTab}
          onChange={(value) => setActiveTab(value)}
          options={options.map((item) => ({
            ...item,
            text: isEn ? item.text : item.textCn || item.text,
          }))}
        />
      )}
      <Tabs
        className={ClassSpecial.TAB_NONE}
        activeId={activeTab}
        tabs={options.map((item) => ({ label: item.text, id: item.value }))}
      >
        {options.map((item, index) => (
          <TabPanel forceRender key={item.value} id={item.value}>
            {children(item, index)}
          </TabPanel>
        ))}
      </Tabs>
    </>
  );
}
